import React from 'react';
import debug from 'debug';
import { Formik, Form } from 'formik';
import { ErrorMessage, Label } from '../FormikCustom';
import Select from 'react-select';
import Spinner from '../Spinner/Spinner';
import { Button } from 'react-bootstrap';
import Dialog from '../Dialogs/Dialog';
import config from '../../config';
import AddPaymentInfo from './AddPaymentInfo';
import apiHelper from '../../api/apiHelper';
import BankAccountView from './BankAccountView';
import CardAccountView from './CardAccountView';
import FormGroup from '../Layout/FormGroup';
import ConfirmEnrollDialog from './ConfirmEnroll';
import { Box, ButtonPanel, TextStyled } from './PaymentSettingsStyled';
import { getPaymentMethods } from '../../api/paymentMethods';
import { api } from '../../api/client';
import { isMethodAlreadyDefaultError, shouldSendSetAsDefaultPut } from './setAsDefaultHelpers';
import { getBackendErrorMessage } from '../../utils/errorMessages';
import { authHeaderConfig } from '../../utils/authHeaderConfig';

import { serverLogger } from '../../libs/datadog-logger/loggers/serverLogger';
import { getCorrelationId } from '../../libs/correlationId';
import { PAYMENT_METHODS_UNKNOWN } from '../PaymentApplication/mopLogMessages';

// Create debug namespaces for payment settings
const debugPayment = debug('auth:payment-settings');
const debugError = debug('auth:error');

class PaymentSettings extends React.Component {
    constructor(props) {
        super(props);
        let me = this;
        me.formRefs = React.createRef();
        me.state = {
            serverError: '',
            success: false,
            showDialog: false,
            showDialogAddPayment: false,
            isDirty: false,
            paymentDetails: { PaymentMethodId: 0 },
            schedule: '',
            paymentMethodsFullData: null,
            paymentMethods: null,
            selectedPaymentMethod: null,
            showAddNewPayment: false,
            disableSubmitButton: false,
            autoPayEnrolled: false,
        };
        me.onSubmitHandler = me.onSubmitHandler.bind(me);
        this.setLoggerContext(props.accountnumber, props.correlationId);
    }

    setLoggerContext(accountnumber, correlationIdFromProps) {
        const cid = correlationIdFromProps || this.correlationId || getCorrelationId(accountnumber);
        if (this.mopLogger && cid === this.correlationId && accountnumber === this.loggerAppNumber) {
            return;
        }
        this.correlationId = cid;
        this.loggerAppNumber = accountnumber;
        this.mopLogger = serverLogger.child({ correlationId: cid, appNumber: accountnumber });
    }
    componentDidMount() {
        this.getPaymentMethods().then(() => {});
        this.updateTitle();
    }
    componentDidUpdate(prevProps) {
        this.setLoggerContext(this.props.accountnumber, this.props.correlationId);
        const me = this;
        if (this.props.accountnumber && this.props.accountnumber !== prevProps.accountnumber) {
            this.setState({ autoPayEnrolled: false }, () => {
                this.getPaymentMethods().then(() => {});
                this.updateTitle();
            });
        }
        if (this.props.payixProfileId && this.props.payixProfileId !== prevProps.payixProfileId) {
            let scheduledPaymentMethod = this.state.paymentMethodsFullData?.find(
                (f) => f.Id === me.props.payixProfileId
            );

            if (scheduledPaymentMethod && me.state.paymentMethods) {
                let selectedPaymentMethod = me.state.paymentMethods?.find((f) => f.value === scheduledPaymentMethod.Id);
                me.handlePaymentMethodsChange(selectedPaymentMethod);
            }
        }
    }
    updateTitle = () => {
        document.title = `Payment Method ${this.props.accountnumber} | ${config.AppTitle}`;
    };

    async getPaymentMethods() {
        const me = this;
        me.setState({ loading: true });
        try {
            //const accountNumber = "41649075";
            const accountNumber = me.props.accountnumber;

            if (accountNumber === '') {
                me.setState({ loading: false });
                return null;
            }
            let paymentMethodsFullData = await getPaymentMethods(accountNumber);
            //paymentMethodsFullData = null;

            if (typeof me.props.onPaymentMethodsLoaded === 'function') {
                me.props.onPaymentMethodsLoaded(Array.isArray(paymentMethodsFullData) ? paymentMethodsFullData.length : 0);
            }

            if (!paymentMethodsFullData || paymentMethodsFullData.length === 0) {
                return await new Promise((resolve) => {
                    me.setState({
                        paymentMethodsFullData: null,
                        paymentMethods: null,
                        selectedPaymentMethod: null,
                        loading: false,
                        showAddNewPayment: true,
                        mode: 'create',
                    }, () => {
                        // Notify parent when automatically showing add new payment (no existing methods)
                        if (typeof me.props.onModeChanged === 'function') {
                            me.props.onModeChanged('create');
                        }

                        resolve({
                            paymentMethodsFullData: null,
                            paymentMethods: null,
                        });
                    });
                });
            }

            //let paymentMethods = paymentMethodsFullData.map(f => ({ value: f.Id, label: f.Name ?? f.NameOnAch }));

            let paymentMethods = [];

            for (let i = 0; i < paymentMethodsFullData.length; i++) {
                let method = paymentMethodsFullData[i];
                let label = apiHelper.getPaymentMethodLabel(method);
                paymentMethods.push({ value: method.Id, label: label });
            }

            return await new Promise((resolve) => {
                me.setState({ paymentMethodsFullData, paymentMethods, loading: false },() => {
                    let scheduledPaymentMethod = me.props.payixProfileId
                        ? paymentMethodsFullData?.find(f => f.Id === me.props.payixProfileId)
                        : paymentMethodsFullData?.find(f => f.IsDefault === true);

                    if (scheduledPaymentMethod) {
                        let selectedPaymentMethod = paymentMethods?.find(f => f.value === scheduledPaymentMethod.Id);
                        if (selectedPaymentMethod) {
                            me.handlePaymentMethodsChange(selectedPaymentMethod);
                        }
                    }
                    resolve({ paymentMethodsFullData, paymentMethods });
                });
            });
        } catch (error) {
            let Message = error?.response?.data?.Message;
            let errorMessage = error.message ? error.message : 'Something went wrong';
            errorMessage = Message ? Message : errorMessage;
            me.setState({ serverError: errorMessage, loading: false });
            // The load settled without a count, so the page can still log that it opened.
            if (typeof me.props.onPaymentMethodsLoaded === 'function') {
                me.props.onPaymentMethodsLoaded(PAYMENT_METHODS_UNKNOWN);
            }
            debugError('getPaymentMethods error: %O', error);

            // Extract only safe fields from error response (avoid logging sensitive payment data)
            const safeErrorDetails = error.response?.data ? {
                message: error.response.data.Message || error.response.data.message,
                errorCode: error.response.data.ErrorCode || error.response.data.errorCode || error.response.data.code,
                statusText: error.response.statusText,
            } : { message: error.message };

            // Truncate message to prevent log bloat (max 500 chars)
            if (safeErrorDetails.message && safeErrorDetails.message.length > 500) {
                safeErrorDetails.message = safeErrorDetails.message.substring(0, 500) + '... [truncated]';
            }

            // Log detailed payment methods fetch failure
            me.mopLogger?.error('PAYMENT_METHODS_LOAD_FAILED', {
                accountNumber: me.props.accountnumber,
                endpoint: 'getPaymentMethods',
                httpStatus: error.response?.status || null,
                errorType: error.name || error.code || 'UnknownError',
                errorMessage: errorMessage,
                errorDetails: safeErrorDetails,
                isTimeout: error.code === 'ECONNABORTED' || error.message?.includes('timeout'),
                isNetworkError: !error.response && error.request,
                correlationId: me.correlationId,
                message: `PaymentSettings: Failed to load payment methods. HTTP Status: ${error.response?.status || 'N/A'}, Error Type: ${error.name || error.code || 'Unknown'}`,
            });
        }
    }
    getExpirationDate(date) {
        if (date === null) return '';
        let dateParts = date.split('-');
        let month = dateParts[0];
        let year = dateParts[1].substr(2, 4);
        let expirationDate = `${month}${year}`;
        return expirationDate;
    }
    getDialog(message, flag, event) {
        const me = this;
        const dialog = flag ? (
            <Dialog
                onClose={event.bind(me)}
                title={message}
                show={flag}
                closeButton="false"
                closeButtonText="OK"
            ></Dialog>
        ) : null;
        return dialog;
    }

    handlePaymentMethodsChange = (selectedPaymentMethod) => {
        const me = this;
        const id = selectedPaymentMethod.value;
        let paymentDetails = {};
        let selectedPaymentMethodDetails = me.state.paymentMethodsFullData.find((f) => f.Id === id);

        /*   debugger;*/

        paymentDetails.Id = selectedPaymentMethodDetails.Id;
        paymentDetails.PaymentMethodId = selectedPaymentMethodDetails.PaymentType;
        paymentDetails.Name = selectedPaymentMethodDetails.Name;
        paymentDetails.NameOnAch = selectedPaymentMethodDetails.NameOnAch;

        paymentDetails.BankName = selectedPaymentMethodDetails.BankName;
        paymentDetails.BankRoutingNumber =
            selectedPaymentMethodDetails.BankRoutingNumber !== null
                ? '************' +
                  selectedPaymentMethodDetails.BankRoutingNumber.substr(
                      selectedPaymentMethodDetails.BankRoutingNumber.length - 4,
                      4
                  )
                : '';
        paymentDetails.BankAccountNumber = '************' + selectedPaymentMethodDetails.LastFour;

        paymentDetails.BillingZip = selectedPaymentMethodDetails.BillingZip;
        paymentDetails.CardBrand = selectedPaymentMethodDetails.CardBrand;
        paymentDetails.CardExpDate =
            selectedPaymentMethodDetails.CardExpDate !== ''
                ? me.getExpirationDate(selectedPaymentMethodDetails.CardExpDate)
                : '';
        paymentDetails.CardImage = selectedPaymentMethodDetails.CardImage;
        paymentDetails.LastFour = selectedPaymentMethodDetails.LastFour;
        paymentDetails.CreditCardNumber = '************' + selectedPaymentMethodDetails.LastFour;

        paymentDetails.Schedule = selectedPaymentMethodDetails.Schedule
            ? selectedPaymentMethodDetails.Schedule.PaymentText
            : '';
        paymentDetails.PaymentType = selectedPaymentMethodDetails.PaymentType;

        paymentDetails.IsDefault = selectedPaymentMethodDetails.IsDefault;
        paymentDetails.Token = selectedPaymentMethodDetails.Token;
        me.setState(
            {
                paymentDetails,
                selectedPaymentMethod: selectedPaymentMethod,
                disableSubmitButton: paymentDetails.IsDefault,
            },
            () => {
                if (typeof me.props.onPaymentMethodChanged === 'function') {
                    me.props.onPaymentMethodChanged(paymentDetails);
                }
            }
        );
    };
    handleDialog() {
        // Log that user has seen the UPDATE success confirmation
        this.mopLogger.info('PaymentSettings: User acknowledged payment method update success', {
            userName: this.props.userName,
            appNumber: this.props.accountnumber,
            flowStage: 'payment_method_update_confirmed',
            action: 'update'
        });

        this.setState({ showDialog: false });
    }
    handleSuccessDialog() {
        // Log that user has seen the ADD success confirmation
        this.mopLogger.info('PaymentSettings: User acknowledged payment method add success', {
            userName: this.props.userName,
            appNumber: this.props.accountnumber,
            flowStage: 'payment_method_add_confirmed',
            action: 'add'
        });

        this.setState({ showDialogAddPayment: false, loading: false });
    }
    handleCancelClick() {
        const me = this;
        me.setState({ loading: true });
        this.getPaymentMethods().then(() => {});
        setTimeout(() => me.setState({ loading: false }), 2000);
    }

    onMakePaymentButtonClick() {
        this.props.history.push(`makeapayment`);
    }

    handleTokenReceived = (tokenData) => {
        // Stashed for use after onAddNewPaymentChange('AdditionCompleted') triggers the methods refresh.
        // Cleared in onAddNewPaymentChange after we've applied set-as-default.
        debugPayment('Payix token received in PaymentSettings: %O', {
            lastFour: tokenData.lastFourDigits,
            paymentType: tokenData.paymentType,
            shouldSetAsDefault: tokenData.shouldSetAsDefault,
        });
        this.pendingTokenContext = tokenData;
    };

    setAsDefaultPaymentMethod = async (paymentMethodFullData) => {
        const me = this;
        const accountNumber = me.props.accountnumber;
        const url = '/recurringPayments/' + accountNumber + '/paymentMethod';
        try {
            // LESSEEPORT-1594: explicit header — the interceptor loses it in the MOP flow
            await api.put(url, paymentMethodFullData, authHeaderConfig(me.props.authToken));
            me.mopLogger?.info('PaymentSettings: New payment method set as default', {
                accountNumber,
                paymentMethodId: paymentMethodFullData.Id,
                paymentType: paymentMethodFullData.PaymentType,
                flowStage: 'set_as_default_after_add',
            });
        } catch (error) {
            if (isMethodAlreadyDefaultError(error)) {
                // Backend no-op: the method is already the default, so this is a
                // success, not an error (LESSEEPORT-1593, same pattern as the
                // LESSEEPORT-1583 autopay no-op fix).
                me.setState({ serverError: '' });
                me.mopLogger?.info('PaymentSettings: Set-as-default no-op, method already default', {
                    accountNumber,
                    paymentMethodId: paymentMethodFullData?.Id,
                    paymentType: paymentMethodFullData?.PaymentType,
                    flowStage: 'set_as_default_noop',
                });
                return;
            }
            const errorMessage = error?.response?.data?.Message || error?.message || 'Failed to set as default';
            debugError('setAsDefaultPaymentMethod error: %O', error);
            me.setState({ serverError: errorMessage });
            me.mopLogger?.error('SET_AS_DEFAULT_FAILED', {
                accountNumber,
                paymentMethodId: paymentMethodFullData?.Id,
                paymentType: paymentMethodFullData?.PaymentType,
                httpStatus: error.response?.status || null,
                errorType: error.name || error.code || 'UnknownError',
                errorMessage,
                isTimeout: error.code === 'ECONNABORTED' || error.message?.includes('timeout'),
                isNetworkError: !error.response && error.request,
                correlationId: me.correlationId,
                message: `PaymentSettings: Failed to set new payment method as default. HTTP Status: ${error.response?.status || 'N/A'}`,
            });
        }
    };

    handleAddPaymentClick = () => {
        const me = this;
        me.setState({ showAddNewPayment: true, mode: 'create' }, () => {
            // Notify parent when entering add new payment mode
            if (typeof me.props.onModeChanged === 'function') {
                me.props.onModeChanged('create');
            }
        });
    };

    onAddNewPaymentChange = async (operation, addedPaymentMethod) => {
        const me = this;
        me.setState({ loading: true });
        if (operation === 'AdditionCompleted') {
            me.setState({ selectedPaymentMethod: null }, () => {
                me.getPaymentMethods().then(async (methodsResult) => {
                    me.setState({
                        showAddNewPayment: false,
                        showDialogAddPayment: true,
                    }, async () => {
                        let matchedFullData = null;
                        if (addedPaymentMethod?.Token) {
                            matchedFullData = methodsResult?.paymentMethodsFullData?.find(
                                (f) => f.Token === addedPaymentMethod.Token
                            );
                            const matchedOption = matchedFullData
                                ? methodsResult?.paymentMethods?.find((m) => m.value === matchedFullData.Id)
                                : null;
                            if (matchedOption) {
                                me.handlePaymentMethodsChange(matchedOption);
                            }
                        }

                        // Tell the parent which method was added, or null when it is not in the refreshed list.
                        if (typeof me.props.onPaymentMethodAdded === 'function') {
                            me.props.onPaymentMethodAdded(matchedFullData);
                        }

                        // If the user checked "Make Default" on the add-payment form,
                        // promote the newly-added method via PUT /recurringPayments/{acct}/paymentMethod.
                        // Skipped when the backend already auto-promoted it (first/only
                        // method case) — sending it anyway gets a 400 "Method Already
                        // Default" (LESSEEPORT-1593).
                        if (shouldSendSetAsDefaultPut(matchedFullData, me.pendingTokenContext)) {
                            await me.setAsDefaultPaymentMethod(matchedFullData);
                            // Refresh once more so the IsDefault flag in state reflects backend.
                            await me.getPaymentMethods();
                        }
                        me.pendingTokenContext = null;

                        if (typeof me.props.onModeChanged === 'function') {
                            me.props.onModeChanged('view');
                        }
                    });
                });
            });
        }
        if (operation === 'Cancel') {
            me.pendingTokenContext = null;
            me.setState({ loading: false }, () => {
                me.getPaymentMethods().then(() => {
                    let paymentMethodsFullData = me.state.paymentMethodsFullData;
                    const showAddNewPayment = paymentMethodsFullData === null;
                    me.setState({
                        showAddNewPayment: showAddNewPayment,
                    }, () => {
                        // Notify parent when canceling add new payment mode
                        if (typeof me.props.onModeChanged === 'function') {
                            me.props.onModeChanged(showAddNewPayment ? 'create' : null);
                        }
                    });
                });
            });
        }
    };

    async onSubmitHandler(values, { setSubmitting }) {
        const me = this;
        const accountNumber = me.props.accountnumber;
        const url = '/recurringPayments/' + accountNumber + '/paymentMethod';
        let payload = me.state.paymentMethodsFullData.find((f) => f.Id === values.Id);
        me.setState({ loading: true });

        await api
            // LESSEEPORT-1594: explicit header — the interceptor loses it in the MOP flow
            .put(url, payload, authHeaderConfig(me.props.authToken))
            .then(function () {
                me.setState({ loading: false, showDialog: true, isDirty: false });
                setSubmitting(false);
                me.getPaymentMethods().then(() => {
                    let paymentMethodsFullData = me.state.paymentMethodsFullData;
                    me.setState({ showAddNewPayment: paymentMethodsFullData === null });
                });
            })
            .catch(function (error) {
                setSubmitting(false);
                if (isMethodAlreadyDefaultError(error)) {
                    // Backend no-op: the method is already the default — show the
                    // normal success confirmation instead of an error
                    // (LESSEEPORT-1593, same pattern as the LESSEEPORT-1583
                    // autopay no-op fix).
                    me.setState({ loading: false, showDialog: true, isDirty: false, serverError: '' });
                    me.mopLogger?.info('PaymentSettings: Set-as-default no-op, method already default', {
                        accountNumber,
                        paymentMethodId: values?.Id || null,
                        flowStage: 'set_as_default_noop',
                    });
                    me.getPaymentMethods().then(() => {
                        let paymentMethodsFullData = me.state.paymentMethodsFullData;
                        me.setState({ showAddNewPayment: paymentMethodsFullData === null });
                    });
                    return;
                }
                me.setState({ loading: false });
                const errorMessage = getBackendErrorMessage(error) || error.message || 'Something went wrong';
                me.setState({ serverError: errorMessage });
                debugError('onSubmitHandler error: %O', error);

                // Extract only safe fields from error response (avoid logging sensitive payment data)
                const safeErrorDetails = error.response?.data ? {
                    message: error.response.data.Message || error.response.data.message,
                    errorCode: error.response.data.ErrorCode || error.response.data.errorCode || error.response.data.code,
                    statusText: error.response.statusText,
                } : { message: error.message };

                // Truncate message to prevent log bloat (max 500 chars)
                if (safeErrorDetails.message && safeErrorDetails.message.length > 500) {
                    safeErrorDetails.message = safeErrorDetails.message.substring(0, 500) + '... [truncated]';
                }

                // Log detailed payment method update failure
                me.mopLogger?.error('PAYMENT_METHOD_UPDATE_FAILED', {
                    accountNumber: accountNumber,
                    endpoint: url,
                    httpStatus: error.response?.status || null,
                    errorType: error.name || error.code || 'UnknownError',
                    errorMessage: errorMessage,
                    errorDetails: safeErrorDetails,
                    isTimeout: error.code === 'ECONNABORTED' || error.message?.includes('timeout'),
                    isNetworkError: !error.response && error.request,
                    paymentMethodId: values?.Id || null,
                    correlationId: me.correlationId,
                    message: `PaymentSettings: Failed to update payment method at ${url}. HTTP Status: ${error.response?.status || 'N/A'}, Error Type: ${error.name || error.code || 'Unknown'}`,
                });
            });
    }
    onConfirmEnrollDialogCancel = () => {
        this.setState({ showConfirmEnrollDialog: false });
    };
    onConfirmEnrollDialogClosed = async () => {
        const enrollInAutoPay = async (accountNumber) => {
            const url = '/payments/' + accountNumber + '/enable-autopay';
            me.setState({ loading: true });

            return await api
                // LESSEEPORT-1594: explicit header — the interceptor loses it in the MOP flow
                .post(url, undefined, authHeaderConfig(me.props.authToken))
                .then(function () {
                    me.setState({
                        loading: false,
                        showDialog: true,
                        isDirty: false,
                        serverError: '',
                        autoPayEnrolled: true,
                    });
                })
                .catch(function (error) {
                    me.setState({ loading: false });
                    const errorMessage = getBackendErrorMessage(error) || error.message || 'Something went wrong';
                    me.setState({ serverError: errorMessage });
                    debugError('enrollInAutoPay error: %O', error);

                    const responseData = error.response?.data;
                    const backendErrorMessage = typeof responseData === 'string'
                        ? responseData
                        : responseData?.Message || responseData?.message || null;

                    me.mopLogger?.error('AUTOPAY_ENROLL_FAILED', {
                        accountNumber: accountNumber,
                        endpoint: url,
                        httpStatus: error.response?.status || null,
                        errorType: error.name || error.code || 'UnknownError',
                        backendError: backendErrorMessage,
                        responseBody: responseData,
                        accountContext: {
                            paymentType: me.state.paymentDetails?.PaymentType,
                            lastFour: me.state.paymentDetails?.LastFour,
                            paymentDay: me.props.selectedAccount?.PaymentDay,
                        },
                        isTimeout: error.code === 'ECONNABORTED' || error.message?.includes('timeout'),
                        isNetworkError: !error.response && error.request,
                        correlationId: me.correlationId,
                        message: `PaymentSettings: Failed to enroll in auto-pay at ${url}. HTTP Status: ${error.response?.status || 'N/A'}, Error Type: ${error.name || error.code || 'Unknown'}, Backend: ${backendErrorMessage || 'N/A'}`,
                    });
                });
        };
        const me = this;
        const accountNumber = me.props.accountnumber;
        await enrollInAutoPay(accountNumber);
        this.setState({ showConfirmEnrollDialog: false });
    };

    render() {
        const me = this;

        const isEnrolledToAutoPay =
            me.state.selectedPaymentMethod &&
            (me.state.autoPayEnrolled ||
                me.props?.selectedAccount?.PaymentMethod === 'ACH' ||
                me.props?.selectedAccount?.PaymentMethod === 'CC');

        const autoPayStatus = isEnrolledToAutoPay ? 'Enrolled' : 'Not Enrolled';

        const frequency =
            me.props.selectedAccount?.PaymentFrequency &&
            me.props?.selectedAccount?.PaymentMethod &&
            me.props?.selectedAccount?.PaymentMethod !== 'Inactive'
                ? me.props.selectedAccount?.PaymentFrequency
                : 'Not Enrolled in Autopay';
        const serverError =
            me.state.serverError !== '' ? (
                <div
                    className="errorMessage"
                    style={{
                        marginBottom: 10,
                    }}
                >
                    {me.state.serverError}
                </div>
            ) : null;

        const enrolledInfo = isEnrolledToAutoPay ? (
            <FormGroup>
                <div>To remove your account from Autopay, please use the Chat or call us at (877) 868-3800</div>
            </FormGroup>
        ) : null;
        const spinner = me.state.loading ? <Spinner /> : null;
        let paymentDetails = me.state.paymentDetails;
        const confirmEnrollDialog = me.state.showConfirmEnrollDialog ? (
            <Dialog
                onClose={me.onConfirmEnrollDialogClosed.bind(me)}
                title="Enroll in Autopay"
                show
                closeButton
                showCancelButton
                onCancel={me.onConfirmEnrollDialogCancel.bind(me)}
                cancelButtonText="Cancel"
                closeButtonText="Enroll"
            >
                <ConfirmEnrollDialog
                    LastFour={me.state.paymentDetails.LastFour}
                    paymentDay={me.props.selectedAccount?.PaymentDay}
                />
            </Dialog>
        ) : null;
        const dialogUpdate = me.getDialog('Payment Method updated successfully.', me.state.showDialog, me.handleDialog);
        const dialogNewPayment = me.getDialog('New Payment Method has added successfully.', me.state.showDialogAddPayment, me.handleSuccessDialog);

        const onEnrollInAutopayButtonClick = () => {
            me.setState({ showConfirmEnrollDialog: true });
            // const accountNumber = me.props.accountnumber;
            // enrollInAutopay(accountNumber);
        };

        // const onDeleteButtonClick = () => {};

        // let selectedPaymentMethodDetails = me.state.paymentMethodsFullData.find((f) => f.Id === id);

        return (
            <div>
                <React.Fragment>
                    {me.state.showAddNewPayment ? (
                        <AddPaymentInfo
                            mode={me.state.mode}
                            accountNumber={me.props.accountnumber}
                            onAddNewPaymentChange={me.onAddNewPaymentChange}
                            onTokenReceived={me.handleTokenReceived}
                        />
                    ) : null}
                    {paymentDetails !== null && !me.state.showAddNewPayment ? (
                        <Formik
                            ref={me.formRefs}
                            enableReinitialize={true}
                            initialValues={paymentDetails}
                            onSubmit={me.onSubmitHandler}
                        >
                            {({ isSubmitting, values }) => (
                                <Form>
                                    <div className="form-group">
                                        <div className="form-group row">
                                            <div className="col-sm-3 col-lg-2 col-form-label">
                                                <Label htmlFor="PaymentMethodId">Payment Method:</Label>
                                            </div>
                                            <div className="col-sm-7 col-form-control">
                                                <Select
                                                    name="PaymentMethodId"
                                                    className="react-select"
                                                    options={me.state.paymentMethods}
                                                    onChange={me.handlePaymentMethodsChange.bind(me)}
                                                    value={me.state.selectedPaymentMethod}
                                                    autoFocus
                                                />
                                                <ErrorMessage
                                                    component="div"
                                                    className="errorMessage"
                                                    name="PaymentMethodId"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {paymentDetails.PaymentMethodId === 2 ? <BankAccountView /> : null}
                                    {paymentDetails.PaymentMethodId === 1 ? <CardAccountView values={values} /> : null}
                                    {serverError}
                                    {spinner}
                                    {dialogUpdate}
                                    {dialogNewPayment}
                                    {confirmEnrollDialog}
                                    <Box hidden={true}>
                                        <FormGroup label={<Label htmlFor="payment-frequency">Frequency:</Label>}>
                                            <TextStyled id="payment-frequency" className="form-control">
                                                {frequency}
                                            </TextStyled>
                                        </FormGroup>
                                        <FormGroup
                                            label={<Label htmlFor="payment-method-account">Payment Method:</Label>}
                                        >
                                            <TextStyled className="form-control">
                                                {me.props?.selectedAccount?.PaymentMethod}
                                            </TextStyled>
                                        </FormGroup>
                                        <FormGroup label={<Label htmlFor="auto-pay-status">Autopay Status:</Label>}>
                                            <TextStyled id="auto-pay-status" className="form-control">
                                                {autoPayStatus}
                                            </TextStyled>
                                        </FormGroup>
                                    </Box>
                                    <ButtonPanel>
                                        <div className="button-group">
                                            {!me.state.showAddNewPayment ? (
                                                <Button
                                                    type="button"
                                                    onClick={(e) => me.handleAddPaymentClick(e)}
                                                    bsStyle="info"
                                                >
                                                    Add new payment method
                                                </Button>
                                            ) : (
                                                ''
                                            )}

                                            {paymentDetails.PaymentMethodId !== 0 && !me.props.hideUpdateButtons ? (
                                                <Button
                                                    type="submit"
                                                    bsStyle="info"
                                                    disabled={isSubmitting || me.state.disableSubmitButton}
                                                >
                                                    Set As Default
                                                </Button>
                                            ) : (
                                                ''
                                            )}
                                            {!isEnrolledToAutoPay ? (
                                                <Button
                                                    type="button"
                                                    bsStyle="success"
                                                    onClick={onEnrollInAutopayButtonClick}
                                                    disabled={isSubmitting}
                                                >
                                                    Enroll in Autopay
                                                </Button>
                                            ) : null}

                                            {paymentDetails.PaymentMethodId !== 0 && !me.props.hideUpdateButtons ? (
                                                <Button
                                                    type="button"
                                                    bsStyle="success"
                                                    disabled={isSubmitting}
                                                    onClick={me.onMakePaymentButtonClick.bind(me)}
                                                >
                                                    Make a payment
                                                </Button>
                                            ) : null}
                                        </div>
                                    </ButtonPanel>
                                    {enrolledInfo}
                                    {/* <Debug />    */}
                                    {/* <Json obj={me.props} color="white" /> */}
                                </Form>
                            )}
                        </Formik>
                    ) : (
                        ''
                    )}
                </React.Fragment>
            </div>
        );
    }
}

export default PaymentSettings;
